<template>
  <tbody>
    <table-service-row
      v-for="item in items.filter(item => item.type === 'service')"
      ref="serviceRow"
      :currency="currency"
      :default-item="item"
      :enabled-elements="enabledElements"
      :enabled-columns="enabledColumns"
      :round-net="roundNet"
      @priceChange="onPriceChange"
    />
    <table-free-word-row
      v-for="item in items.filter(item => item.type === 'free-word')"
      ref="freeWordRow"
      :currency="currency"
      :default-item="item"
      :enabled-elements="enabledElements"
      :enabled-columns="enabledColumns"
      :round-net="roundNet"
      @priceChange="onPriceChange"
    />
    <table-row
      v-for="item in items.filter(item => item.type === 'product')"
      ref="row"
      :key="item.id"
      :auto-select-stock="autoSelectStock"
      :default-item="item"
      :custom-prices="customPrices"
      :price-type="priceType"
      :currency="currency"
      :min-count="minCount"
      :enabled-elements="enabledElements"
      :enabled-columns="enabledColumns"
      :compare-items="compareItems && compareItems.filter(i => i.product_pack_type_id === item.product_pack_type.id)"
      :default-supplier="defaultSupplier"
      :compare-type="compareType"
      :is-vat-zero="isVatZero"
      :is-product-select-from-stock="isProductSelectFromStock"
      :available-products="availableProducts"
      :load-base-count-from-stock="loadBaseCountFromStock"
      :storage-id="storageId"
      :round-net="roundNet"
      :show-row-warning="showRowWarning"
      @priceChange="onPriceChange"
    />
  </tbody>
</template>
<script>
import TableRow from './TableRow';
import TableServiceRow from './TableServiceRow';
import TableFreeWordRow from './TableFreeWordRow';

export default {
  components: {
    TableRow,
    TableServiceRow,
    TableFreeWordRow,
  },
  props: {
    customPrices: {
      type: Array,
      default() {
        return [];
      },
      required: false,
    },
    displayAddFreeWordItem: {
      type: Boolean,
      default() {
        return false;
      },
      required: false,
    },
    items: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    currency: {
      type: String,
      default() {
        return 'HUF';
      },
      required: false,
    },
    autoSelectStock: {
      type: Boolean,
      default() {
        return false;
      },
      required: false,
    },
    defaultSupplier: {
      type: Object,
      default() {
        return null;
      },
      required: false,
    },
    priceType: {
      type: String,
      default() {
        return 'purchase_price';
      },
      required: false,
    },
    enabledElements: {
      type: Array,
      default() {
        return ['addButton', 'deleteButton', 'product', 'pack', 'count', 'netPrice', 'vat', 'unitPrice', 'expirationDate', 'expirationDateSelector', 'supplierSelector'];
      },
      required: false,
    },
    minCount: {
      type: Number,
      default() {
        return 1;
      },
      required: false,
    },
    enabledColumns: {
      type: Array,
      default() {
        return ['product', 'productPackType', 'expirationDate', 'supplierSelector', 'count', 'unitPrice', 'netPrice', 'vat', 'actions'];
      },
      required: false,
    },
    roundNet: {
      type: Boolean,
      default() {
        return false;
      },
      required: false,
    },
    compareItems: {
      type: Array,
      default() {
        return null;
      },
      required: false,
    },
    compareType: {
      type: String,
      default() {
        return 'diff';
      },
      required: false,
    },
    isVatZero: {
      type: Boolean,
      default() {
        return false;
      },
      required: false,
    },
    isProductSelectFromStock: {
      type: Boolean,
      default() {
        return true;
      },
      required: false,
    },
    availableProducts: {
      validator: prop => typeof prop === 'object' || prop === null,
      default() {
        return null;
      },
      required: false,
    },
    loadBaseCountFromStock: {
      type: Boolean,
      default() {
        return true;
      },
      required: false,
    },
    storageId: {
      type: Number,
      default() {
        return 9;
      }
    },
    showRowWarning: {
      type: Boolean,
      default() {
        return false;
      },
      required: false,
    },
  },
  methods: {
    getKey() {
      return Math.random()
        .toString(36)
        .substring(7);
    },
    onPriceChange() {
      this.$emit('priceChange')
    },
    getItems() {
      const items = [];
      if (this.$refs['row']) {
        this.$refs['row'].forEach(row => !row.item.deleted && items.push(row.item));
      }
      if (this.$refs['serviceRow']) {
        this.$refs['serviceRow'].forEach(row => !row.item.deleted && items.push(row.item));
      }
      if (this.$refs['freeWordRow']) {
        this.$refs['freeWordRow'].forEach(row => !row.item.deleted && items.push(row.item));
      }
      return items;
    },
    validateSuppliers() {
      let valid = true;
      this.$refs['row'].forEach(row => {
        if(!row.validateSupplier() && !row.item.deleted) {
          valid = false;
        }
      });
      return valid;
    },
    validateExpirationDates() {
      let valid = true;
      this.$refs['row'].forEach(row => {
        if(!row.validateExpirationDate() && !row.item.deleted) {
          valid = false;
        }
      });
      return valid;
    },
  },
};
</script>
